export default {
      id: "tt-italic-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#tt-italic",
      toString: function () {
        return this.url;
      }
    }